import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20night%20scene%20of%20a%20crowd%20of%20people%20holding%20smartphones%20up%20toward%20a%20glowing%20stage%2C%20warm%20golden%20and%20deep%20red%20lighting%2C%20concert-like%20atmosphere%2C%20silhouettes%20of%20people%20against%20dramatic%20stage%20lights%2C%20mysterious%20and%20energetic%20mood%2C%20editorial%20style%2C%20high%20contrast%2C%20professional%20cinematography%20quality%2C%20dark%20ambient%20background%20with%20warm%20highlights%2C%20no%20identifiable%20faces&width=1920&height=900&seq=gossip-hero-bg&orientation=landscape"
          alt="吃瓜网 - 八卦有理 吃瓜无罪"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/35 to-black/50"></div>

      {/* Content */}
      <div className="relative z-10 w-full h-full flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="max-w-2xl">
              {/* Badge */}
              <span className="inline-block px-4 py-1.5 border border-white/40 rounded-full text-white/90 text-xs md:text-sm font-medium mb-6 backdrop-blur-sm">
                🔥 全网最速吃瓜平台
              </span>

              {/* Headline */}
              <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white leading-tight mb-4">
                八卦有理
                <br />
                <span className="text-accent-300">吃瓜无罪</span>
              </h1>

              {/* Subtitle */}
              <p className="text-white/70 text-sm md:text-base leading-relaxed mb-8 max-w-lg">
                明星八卦黑料大全 · 网红翻车实锤 · 擦边内容聚合
                <br />
                全民参与爆料大赛，抢占吃瓜第一排！
              </p>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-3">
                <Link
                  to="/category/star-gossip"
                  className="whitespace-nowrap inline-flex items-center justify-center px-6 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all duration-300 cursor-pointer"
                >
                  立即吃瓜 <i className="ri-arrow-right-line ml-2"></i>
                </Link>
                <Link
                  to="/about"
                  className="whitespace-nowrap inline-flex items-center justify-center px-6 py-3 rounded-full bg-white/15 backdrop-blur-sm text-white border border-white/30 font-medium text-sm hover:bg-white/25 transition-all duration-300 cursor-pointer"
                >
                  参与爆料大赛 <i className="ri-send-plane-line ml-2"></i>
                </Link>
              </div>

              {/* Stats */}
              <div className="flex items-center gap-6 md:gap-10 mt-10">
                <div>
                  <p className="text-white text-lg md:text-2xl font-bold font-heading">12,860+</p>
                  <p className="text-white/50 text-xs">明星八卦爆料</p>
                </div>
                <div className="w-px h-8 bg-white/20"></div>
                <div>
                  <p className="text-white text-lg md:text-2xl font-bold font-heading">9,540+</p>
                  <p className="text-white/50 text-xs">网红翻车实锤</p>
                </div>
                <div className="w-px h-8 bg-white/20"></div>
                <div>
                  <p className="text-white text-lg md:text-2xl font-bold font-heading">580万+</p>
                  <p className="text-white/50 text-xs">忠实吃瓜群众</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white/60 text-2xl"></i>
      </div>
    </section>
  );
}